// extracted by css-extract-rspack-plugin
export default {"trigger":"trigger-tHx9XT"};